<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">{{ title }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row>
                    <v-col cols="12">
                        The rating will be set to "Accepted"<br>
                        <br>
                        <!-- {{ actions }} -->
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="12" class="pt-6">
                        <v-textarea v-model="question.oavr_antwoord_def" :rows=10 variant="outlined" :readonly="true" outlined />
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
                <btn_component data="" type="text" color="primary" text="Accept" tooltip="Actions will be executed" size="small" @actionClick="acceptAction"/>
                <v-spacer></v-spacer>
                <!-- <btn_component data="" type="text" color="primary" text="view mail" tooltip="email preview" size="small" @actionClick="viewEmail"/> -->
                <btn_component data="" type="text" color="error" text="cancel" tooltip="Back to the question" size="small" @actionClick="cancelAction"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    export default {
        components: {
            btn_component,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                title: "",
                actions: "",
                question: {},
            }
        },
        methods: { 
            openDialog(question) {
                this.question = question;
                this.new_rating = this.question.oavr_rating;
                if (this.question.oavr_antwoord_org === this.question.oavr_antwoord_def) {
                    this.title = "Accept the answer from chatGPT";
                } else {
                    this.title = "Accept the (manually modified) answer from chatGPT";
                }
                if (this.question.oavr_antwoord_def === "") {
                    this.actions = "The question will be forwarded to belco, it needs to be ansered there."
                } else {
                    this.actions = "The answer will be sent to the guest, a copy will be sent to belco as closed."
                }
                this.dialog = true;
            },
            acceptAction() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/questionAcceptResult.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "questionAcceptResult"
                    },
                    questionAcceptResult: {
                        oavr_encrid: this.question.oavr_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.questionAcceptResult.text,
                            color: res.data.questionAcceptResult.color
                        });
                        this.$emit("updateAction", "accepted");
                        this.closeDialog();
                    }
                });
            },
            cancelAction() {
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>